
import { v4 as uuidv4 } from 'uuid';
import { add } from 'date-fns';

// Mock company details
export const companyDetails = {
  name: "Acme Corporation",
  address: {
    street: "123 Business Road",
    city: "Enterprise City",
    state: "CA",
    zipCode: "94105",
    country: "USA"
  },
  phone: "+1 (555) 123-4567",
  email: "invoicing@acmecorp.com",
  website: "www.acmecorp.com",
  taxId: "TAX-12345-US",
  logo: "/placeholder.svg"
};

// Mock customers
export const mockCustomers = [
  {
    id: "cus-001",
    name: "TechStart Industries",
    contactName: "John Smith",
    phone: "+1 (555) 987-6543",
    email: "john@techstart.com",
    address: {
      street: "456 Innovation Avenue",
      city: "San Francisco",
      state: "CA",
      zipCode: "94107",
      country: "USA"
    }
  },
  {
    id: "cus-002",
    name: "Global Services Ltd",
    contactName: "Emma Johnson",
    phone: "+1 (555) 123-7890",
    email: "emma@globalservices.com",
    address: {
      street: "789 Corporate Drive",
      city: "New York",
      state: "NY",
      zipCode: "10001",
      country: "USA"
    }
  },
  {
    id: "cus-003",
    name: "EcoSolutions Inc",
    contactName: "Michael Brown",
    phone: "+1 (555) 456-7890",
    email: "michael@ecosolutions.com",
    address: {
      street: "321 Green Street",
      city: "Portland",
      state: "OR",
      zipCode: "97201",
      country: "USA"
    }
  }
];

// Mock invoice items
export const mockInvoiceItems = [
  {
    id: uuidv4(),
    name: "Web Development Services",
    description: "Custom website development",
    price: 1500,
    quantity: 1,
    tax: 7.5
  },
  {
    id: uuidv4(),
    name: "UI/UX Design",
    description: "User interface design for mobile app",
    price: 800,
    quantity: 1,
    tax: 7.5
  },
  {
    id: uuidv4(),
    name: "Database Setup",
    description: "Migration and setup of cloud database",
    price: 500,
    quantity: 1,
    tax: 7.5
  },
  {
    id: uuidv4(),
    name: "API Integration",
    description: "Third-party API integration",
    price: 600,
    quantity: 1,
    tax: 7.5
  },
  {
    id: uuidv4(),
    name: "Maintenance Contract",
    description: "Monthly website maintenance",
    price: 200,
    quantity: 1,
    tax: 7.5
  },
  {
    id: uuidv4(),
    name: "Server Configuration",
    description: "Server setup and configuration",
    price: 350,
    quantity: 1,
    tax: 7.5
  }
];

// Mock invoices with customers that match IDs in mockData.ts
export const mockInvoices = [
  {
    id: "8f2f9510-0695-4849-ab1b-9ee3c41ab0af",
    invoiceNumber: "INV-2501-001",
    customer: mockCustomers[0], // Use customer with ID cust-001
    invoiceDate: new Date(),
    dueDate: add(new Date(), { days: 30 }),
    items: [mockInvoiceItems[0], mockInvoiceItems[1]],
    status: "pending",
    subtotal: 2300,
    taxTotal: 172.5,
    total: 2472.5,
    notes: "Thank you for your business!"
  },
  {
    id: "inv-002",
    invoiceNumber: "INV-2501-002",
    customer: mockCustomers[1], // Use customer with ID cust-002
    invoiceDate: new Date(2025, 3, 1),
    dueDate: new Date(2025, 4, 1),
    items: [mockInvoiceItems[2], mockInvoiceItems[3]],
    status: "paid",
    subtotal: 1100,
    taxTotal: 82.5,
    total: 1182.5,
    notes: "Payment received. Thank you!"
  },
  {
    id: "inv-003",
    invoiceNumber: "INV-2501-003",
    customer: mockCustomers[2], // Use customer with ID cust-003
    invoiceDate: new Date(2025, 2, 15),
    dueDate: new Date(2025, 3, 15),
    items: [mockInvoiceItems[4], mockInvoiceItems[5]],
    status: "overdue",
    subtotal: 550,
    taxTotal: 41.25,
    total: 591.25,
    notes: "Please remit payment as soon as possible."
  },
  {
    id: "inv-004",
    invoiceNumber: "INV-2501-004",
    customer: mockCustomers[0], // Use customer with ID cust-001
    invoiceDate: new Date(2025, 2, 1),
    dueDate: new Date(2025, 3, 1),
    items: [mockInvoiceItems[0], mockInvoiceItems[5]],
    status: "paid",
    subtotal: 1850,
    taxTotal: 138.75,
    total: 1988.75,
    notes: "Thank you for your prompt payment!"
  }
];

// Generate invoice number
export const generateInvoiceNumber = () => {
  const prefix = "INV";
  const currentDate = new Date();
  const year = currentDate.getFullYear().toString().substr(-2);
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');

  return `${prefix}-${year}${month}-${random}`;
};
